import React from 'react';
import { defaultStyles, FileIcon as ReactFileIcon } from 'react-file-icon';

export const FileIcon = ({
  extension,
  defaultStylesProp,
}: {
  extension: string | undefined;
  defaultStylesProp?: Record<any, any>;
}) => {
  return (
    // @ts-ignore
    <ReactFileIcon
      extension={extension}
      {...(defaultStylesProp ?? defaultStyles[extension as keyof typeof defaultStyles])}
      labelUppercase
    />
  );
};
